import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminDigitalOrderConfigsDigitalOrderConfigRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ digital_order_config_id }) {
    const { content } = await this.store.request(
      findRecord('digital-order-config', digital_order_config_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
